import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { Users, FunctionSquare, ClipboardList, Gift } from 'lucide-react';
import Header from '../components/Header';
import WeeklyQuota from '../components/WeeklyQuota';

const Dashboard: React.FC = () => {
  const { user } = useAuth();
  const navigate = useNavigate();

  if (!user) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-100 dark:bg-gray-900">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-indigo-600 dark:border-indigo-400"></div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-100 dark:bg-gray-900">
      <Header />
      <main className="max-w-7xl mx-auto py-6 sm:px-6 lg:px-8">
        <div className="px-4 py-6 sm:px-0">
          {/* Weekly Quota */}
          <div className="mb-6">
            <WeeklyQuota />
          </div>

          {/* Menu Grid */}
          <div className="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3">
            {(user?.role === 'admin' || user?.role === 'supervisor') && (
              <div
                onClick={() => navigate('/admin')}
                className="bg-white dark:bg-gray-800 overflow-hidden shadow rounded-lg cursor-pointer hover:shadow-lg transition-shadow duration-200"
              >
                <div className="px-4 py-5 sm:p-6">
                  <div className="flex items-center">
                    <Users className="h-8 w-8 text-indigo-600 dark:text-indigo-400" />
                    <h3 className="ml-3 text-lg font-medium text-gray-900 dark:text-white">Admin Panel</h3>
                  </div>
                  <p className="mt-2 text-sm text-gray-500 dark:text-gray-400">
                    Manage users, view logs, and handle administrative tasks
                  </p>
                </div>
              </div>
            )}

            <div
              onClick={() => navigate('/functions')}
              className="bg-white dark:bg-gray-800 overflow-hidden shadow rounded-lg cursor-pointer hover:shadow-lg transition-shadow duration-200"
            >
              <div className="px-4 py-5 sm:p-6">
                <div className="flex items-center">
                  <FunctionSquare className="h-8 w-8 text-indigo-600 dark:text-indigo-400" />
                  <h3 className="ml-3 text-lg font-medium text-gray-900 dark:text-white">Functions</h3>
                </div>
                <p className="mt-2 text-sm text-gray-500 dark:text-gray-400">
                  Access tools and utilities for your daily tasks
                </p>
              </div>
            </div>

            <div
              onClick={() => navigate('/resolution-center')}
              className="bg-white dark:bg-gray-800 overflow-hidden shadow rounded-lg cursor-pointer hover:shadow-lg transition-shadow duration-200"
            >
              <div className="px-4 py-5 sm:p-6">
                <div className="flex items-center">
                  <ClipboardList className="h-8 w-8 text-indigo-600 dark:text-indigo-400" />
                  <h3 className="ml-3 text-lg font-medium text-gray-900 dark:text-white">Resolution Center</h3>
                </div>
                <p className="mt-2 text-sm text-gray-500 dark:text-gray-400">
                  View and manage your assigned account issues
                </p>
              </div>
            </div>

            <div
              onClick={() => navigate('/rewards')}
              className="bg-white dark:bg-gray-800 overflow-hidden shadow rounded-lg cursor-pointer hover:shadow-lg transition-shadow duration-200"
            >
              <div className="px-4 py-5 sm:p-6">
                <div className="flex items-center">
                  <Gift className="h-8 w-8 text-indigo-600 dark:text-indigo-400" />
                  <h3 className="ml-3 text-lg font-medium text-gray-900 dark:text-white">Reward Center</h3>
                </div>
                <p className="mt-2 text-sm text-gray-500 dark:text-gray-400">
                  Exchange RP for rewards and balance
                </p>
              </div>
            </div>
          </div>
        </div>
      </main>
    </div>
  );
};

export default Dashboard;